import { render } from "./manageUser.vue?vue&type=template&id=1e5e6789"
import script from "./manageUser.vue?vue&type=script&lang=js"
export * from "./manageUser.vue?vue&type=script&lang=js"

import "./manageUser.vue?vue&type=style&index=0&id=1e5e6789&lang=scss"

import exportComponent from "C:\\Users\\DELL\\source\\repos\\project0810frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render]])